function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.2222 0H1.77778C0.8 0 0 0.8 0 1.77778V14.2222C0 15.2 0.8 16 1.77778 16H14.2222C15.2 16 16 15.2 16 14.2222V1.77778C16 0.8 15.2 0 14.2222 0ZM12.4444 14.2222H3.55556V14.0089C4.81778 12.9956 6.36444 12.4444 8 12.4444C9.63556 12.4444 11.1822 12.9956 12.4444 14.0089V14.2222ZM14.2222 13.2089C12.6222 11.6356 10.4267 10.6667 8 10.6667C5.57333 10.6667 3.37778 11.6356 1.77778 13.2089V1.77778H14.2222V13.2089ZM8 8.88889C9.71556 8.88889 11.1111 7.49333 11.1111 5.77778C11.1111 4.06222 9.71556 2.66667 8 2.66667C6.28444 2.66667 4.88889 4.06222 4.88889 5.77778C4.88889 7.49333 6.28444 8.88889 8 8.88889ZM8 4.44444C8.73778 4.44444 9.33333 5.04 9.33333 5.77778C9.33333 6.51556 8.73778 7.11111 8 7.11111C7.26222 7.11111 6.66667 6.51556 6.66667 5.77778C6.66667 5.04 7.26222 4.44444 8 4.44444Z",
  fill: "#707274"
});

function SvgEmptyProfileCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyProfileCard);
export default __webpack_public_path__ + "static/media/empty_profile_card.21c422ff.svg";
export { ForwardRef as ReactComponent };